import { UpperCasePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, NgZone, ChangeDetectorRef, OnDestroy, output, inject, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, Validators,UntypedFormControl } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { StyleClassModule } from 'primeng/styleclass';
import { LostDealBannerComponent } from '../lost-deal-banner/lost-deal-banner.component';

import { InputMaskModule } from 'primeng/inputmask';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { FactoryHttpLoader } from '@fitness-force/shared';
import { ErrorMsgComponent } from '@fitness-force/errors';;
import { OpportunityBoardType } from '@fitness-force/enum';
import { GooglePlacesComponent } from '@fitness-force/common/google-places';
import { CONSTANTS_DATA } from '@fitness-force/constants';

import { ToastMessageService,ClientService,OpportunityService } from '@fitness-force/api';
import { InputNumberComponent } from '@fitness-force/common-input-number';


@Component({
  selector: 'app-lost-deal-reason',
  templateUrl: './lost-deal-reason.component.html',
  styleUrls: ['./lost-deal-reason.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    ErrorMsgComponent,
    DialogModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    StyleClassModule,
    SelectModule,
    ReactiveFormsModule,
    FormsModule,
    DatePickerModule,
    LostDealBannerComponent,
    AutoCompleteModule,
    InputMaskModule,
    GooglePlacesComponent,
    InputNumberComponent,
    UpperCasePipe
]
})
export class LostDealReasonComponent implements OnInit, OnDestroy {
  private readonly   toastMessageService = inject(ToastMessageService);
  private readonly clientService = inject(ClientService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly ngZone = inject(NgZone);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly translate = inject(TranslateService);
  private readonly oppService = inject(OpportunityService);

  readonly reason = input<any>({ title: '', name: '' });
  readonly showLostReason = input(false);
  readonly dealInfo = input<any>();
  readonly goBack = output<boolean>();
  readonly closeDailogs = output<boolean>();
  readonly reloadData = output();
  contractEndDate: Date | undefined;
  selectedReason: any;
  reasons = CONSTANTS_DATA.LOST_DEALS_OTHER_REASONS;
  tags: string[] | undefined;

  lostToCompetitors: UntypedFormGroup = new UntypedFormGroup({})
  lostDueToHighPrice: UntypedFormGroup = new UntypedFormGroup({})
  missingFacility: UntypedFormGroup = new UntypedFormGroup({})
  otherReasons: UntypedFormGroup = new UntypedFormGroup({})
  notContactable: UntypedFormGroup = new UntypedFormGroup({})
  lostDealModal = {}
  latitude: number | any;
  longitude: number | any;
  placeId = ''

  ngOnInit(): void {

    this.componentInit();
  }


  componentInit() {
    this.lostToCompetitors = this.fb.group({
      competitorName: [''],
      contractEndDate: ['', [Validators.required]],
      lostToCompetitorComments: ['', [Validators.required]]
    })
    this.lostDueToHighPrice = this.fb.group({
      expectedPrice: ['', []],
      lostHighPriceComments: ['', [Validators.required]]
    })
    this.missingFacility = this.fb.group({
      selectFacilities: ['', [Validators.required]],
      missingFacilityComments: ['', [Validators.required]]
    })
    this.otherReasons = this.fb.group({
      reason: ['', [Validators.required]],
      otherReasonsComments: ['', [Validators.required]]
    })
    this.notContactable = this.fb.group({
      notContactableComments: ['', [Validators.required]]
    })

  }

  get CompetitorName(): UntypedFormControl {
    return this.lostToCompetitors.get('competitorName') as UntypedFormControl;
  }
  get ContractEndDate(): UntypedFormControl {
    return this.lostToCompetitors.get('contractEndDate') as UntypedFormControl;
  }
  get LostToCompetitorComments(): UntypedFormControl {
    return this.lostToCompetitors.get('lostToCompetitorComments') as UntypedFormControl;
  }
  get ExpectedPrice(): UntypedFormControl {
    return this.lostDueToHighPrice.get('expectedPrice') as UntypedFormControl;
  }
  get LostHighPriceComments(): UntypedFormControl {
    return this.lostDueToHighPrice.get('lostHighPriceComments') as UntypedFormControl;
  }
  get SelectFacilities(): UntypedFormControl {
    return this.missingFacility.get('selectFacilities') as UntypedFormControl;
  }
  get MissingFacilityComments(): UntypedFormControl {
    return this.missingFacility.get('missingFacilityComments') as UntypedFormControl;
  }
  get Reason(): UntypedFormControl {
    return this.otherReasons.get('reason') as UntypedFormControl;
  }
  get OtherReasonsComments(): UntypedFormControl {
    return this.otherReasons.get('otherReasonsComments') as UntypedFormControl;
  }
  get NotContactableComments(): UntypedFormControl {
    return this.notContactable.get('notContactableComments') as UntypedFormControl;
  }

  closeReasonDailog() {
    this.goBack.emit(false)
    this.resetDialogs()
  }
  closeAllDialogs() {
    this.resetDialogs()
    this.closeDailogs.emit(true)
  }


  saveLostAsDeal(type: string) {
    if (type == 'LostToCompetitor') {
      this.lostDealModal = {
        "reason_type": "LostToCompetitor",
        "reason_other": null,
        "competitor_name": this.CompetitorName.value ? this.CompetitorName.value : "",
        "competitor_latitude": this.latitude ? this.latitude.toString():0,
        "competitor_longitude": this.longitude ? this.longitude.toString() : 0,
        "competitor_place_id": this.placeId,
        "contract_end_date": this.ContractEndDate.value,
        "expected_price_in_minor_currency": null,
        "missing_facility": null,
        "comments": this.LostToCompetitorComments.value
      }
    } else if (type == 'HighPrice') {
      this.lostDealModal = {
        "reason_type": "HighPrice",
        "reason_other": null,
        "competitor_name": null,
        "competitor_latitude": null,
        "competitor_longitude": null,
        "competitor_place_id": null,
        "contract_end_date": null,
        "expected_price_in_minor_currency": (this.ExpectedPrice.value) ? this.ExpectedPrice.value : 0,
        "missing_facility": null,
        "comments": this.LostHighPriceComments.value
      }
    } else if (type == 'MissingFacility') {
      this.lostDealModal = {
        "reason_type": "MissingFacility",
        "reason_other": null,
        "competitor_name": null,
        "competitor_latitude": null,
        "competitor_longitude": null,
        "competitor_place_id": null,
        "contract_end_date": null,
        "expected_price_in_minor_currency": null,
        "missing_facility": this.SelectFacilities.value,
        "comments": this.MissingFacilityComments.value
      }
    } else if (type == 'OtherReasons') {
      this.lostDealModal = {
        "reason_type": "Other",
        "reason_other": this.Reason.value.name,
        "competitor_name": null,
        "competitor_latitude": null,
        "competitor_longitude": null,
        "competitor_place_id": null,
        "contract_end_date": null,
        "expected_price_in_minor_currency": null,
        "missing_facility": null,
        "comments": this.OtherReasonsComments.value
      }
    } else if (type == 'NotContactable') {
      this.lostDealModal = {
        "reason_type": "NotContactable",
        "reason_other": null,
        "competitor_name": null,
        "competitor_latitude": null,
        "competitor_longitude": null,
        "competitor_place_id": null,
        "contract_end_date": null,
        "expected_price_in_minor_currency": null,
        "missing_facility": null,
        "comments": this.NotContactableComments.value
      }
    }
    const dealInfoValue = this.dealInfo();
    if (!dealInfoValue) {
      return;
    }
    this.oppService.OpportunityMarkAsLost(dealInfoValue.tenant_id, OpportunityBoardType.NewMemberBoard, dealInfoValue.id, this.lostDealModal).subscribe((res: any) => {
      this.closeAllDialogs()
      this.toastMessageService.showSuccess(this.translate.instant('OPPORTUNITY.LOSTDEAL.MARKED_AS_LOST'));
      this.reloadData.emit(res)
    })
  }

  getPlaceDetails(place: any) {

    this.latitude = place.geometry.location.lat()
    this.longitude = place.geometry.location.lng()
    this.placeId = place.place_id
  }

  resetDialogs() {
    this.latitude = '';
    this.longitude = '';
    this.placeId = '';
    this.lostToCompetitors.reset();
    this.lostDueToHighPrice.reset();
    this.missingFacility.reset();
    this.otherReasons.reset();
    this.notContactable.reset();
  }

  ngOnDestroy(): void {
    this.resetDialogs()
  }

  clientStatus(client: any): string {
    if (client?.status)
      return this.clientService.getClientStatusHtml(client.status.toString());
    else
      return '';
  }
}
